import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from 'components/LoadingSpinner';

const FullHeightSpinner = ({ text = '' }) => (
  <div
    className="flex items-center justify-center flex-col gap-8"
    style={{ height: 'calc(100vh - 100px)' }}
  >
    <LoadingSpinner message="" label={text || 'Loading'} />
    <p className="text-base font-semibold tracking-tight">{text}</p>
  </div>
);

FullHeightSpinner.propTypes = {
  text: PropTypes.string
};

export default FullHeightSpinner;
